import { render, staticRenderFns } from "./FilesEdit.vue?vue&type=template&id=aa34020e"
import script from "./FilesEdit.vue?vue&type=script&lang=ts"
export * from "./FilesEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports